export default {
    NODE_REPOSITORY: 'repository',
    NODE_FOLDER: 'folder',
    NODE_FILE: 'file',
    NODE_JOB_DEFINITION: 'job_definition',
}
